import Notifications from 'react-notification-system-redux';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { getRequestErrorMessage } from '../../utilities/SagasHelper';
import * as api from '../../utilities/ServiceManager';
import {
  setAbbreviationsQueueStats,
  setAudioGenerationQueueStats,
} from './actionSagas';
import {
  GET_ABBREVIATIONS_QUEUE_STATS,
  GET_AUDIO_GENERATION_QUEUE_STATS,
  UPDATE_ABBREVIATIONS_JOBS,
  UPDATE_AUDIO_GENERATION_JOBS,
} from './actionTypes';

function* getAudioGenerationQueueStats() {
  yield takeLatest(
    GET_AUDIO_GENERATION_QUEUE_STATS,
    getAudioGenerationQueueStatsSaga,
  );
}

function* getAudioGenerationQueueStatsSaga() {
  try {
    const response = yield call(api.getAudioGenerationQueueStats);
    yield put(setAudioGenerationQueueStats(response));
  } catch (exception) {
    yield put(showNotificationErrorFromException(exception));
  }
}

function* getAbbreviationsQueueStats() {
  yield takeLatest(
    GET_ABBREVIATIONS_QUEUE_STATS,
    getAbbreviationsQueueStatsSaga,
  );
}

function* getAbbreviationsQueueStatsSaga() {
  try {
    const response = yield call(api.getAbbreviationsQueueStats);
    yield put(setAbbreviationsQueueStats(response));
  } catch (exception) {
    yield put(showNotificationErrorFromException(exception));
  }
}

function* updateAudioGeneration() {
  yield takeLatest(UPDATE_AUDIO_GENERATION_JOBS, updateAudioGenerationSaga);
}

function* updateAudioGenerationSaga(action) {
  try {
    yield call(api.updateAudioGeneration, action.action);
    const response2 = yield call(api.getAudioGenerationQueueStats);
    yield put(setAudioGenerationQueueStats(response2));
  } catch (exception) {
    yield put(showNotificationErrorFromException(exception));
  }
}

function* updateAbbreviations() {
  yield takeLatest(UPDATE_ABBREVIATIONS_JOBS, updateAbbreviationsSaga);
}

function* updateAbbreviationsSaga(action) {
  try {
    yield call(api.updateAbbreviations, action.action);
    const response = yield call(api.getAbbreviationsQueueStats);
    yield put(setAbbreviationsQueueStats(response));
  } catch (exception) {
    yield put(showNotificationErrorFromException(exception));
  }
}

function showNotificationErrorFromException(exception) {
  const message = getRequestErrorMessage(exception);

  return Notifications.show({ title: 'Ops!', message }, 'error');
}

export default function* sagas() {
  yield all([
    getAudioGenerationQueueStats(),
    getAbbreviationsQueueStats(),
    updateAudioGeneration(),
    updateAbbreviations(),
  ]);
}
